var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CommandService_commandInfo, _CommandService_commandHandlers;
import mergeRegister from '../../Hooks/mergeRegister';
export class CommandService {
    constructor(keyboardService, generateUuid) {
        this.keyboardService = keyboardService;
        this.generateUuid = generateUuid;
        _CommandService_commandInfo.set(this, new Map());
        _CommandService_commandHandlers.set(this, new Map());
    }
    add(id, description, handler, icon, shortcut_id) {
        __classPrivateFieldGet(this, _CommandService_commandInfo, "f").set(id, { description, icon: icon !== null && icon !== void 0 ? icon : 'info', shortcut_id });
        __classPrivateFieldGet(this, _CommandService_commandHandlers, "f").set(id, handler);
        return () => {
            __classPrivateFieldGet(this, _CommandService_commandInfo, "f").delete(id);
            __classPrivateFieldGet(this, _CommandService_commandHandlers, "f").delete(id);
        };
    }
    addWithShortcut(id, category, description, handler, icon) {
        var _a;
        return mergeRegister(this.add((_a = id.description) !== null && _a !== void 0 ? _a : this.generateUuid.execute().getValue(), description, handler, icon, id), this.keyboardService.addCommandHandler({ command: id, category, description, onKeyDown: handler }));
    }
    triggerCommand(id) {
        const handler = __classPrivateFieldGet(this, _CommandService_commandHandlers, "f").get(id);
        if (handler) {
            handler();
        }
    }
    getCommandDescriptions() {
        const descriptions = [];
        for (const [id, { description, icon, shortcut_id }] of __classPrivateFieldGet(this, _CommandService_commandInfo, "f")) {
            descriptions.push({ id, description, icon, shortcut_id });
        }
        return descriptions;
    }
    getCommandDescription(id) {
        const command = __classPrivateFieldGet(this, _CommandService_commandInfo, "f").get(id);
        if (!command) {
            return;
        }
        return { id, ...command };
    }
}
_CommandService_commandInfo = new WeakMap(), _CommandService_commandHandlers = new WeakMap();
